
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.5 3h11A2.503 2.503 0 0 1 20 5.5v13a2.503 2.503 0 0 1-2.5 2.5h-11A2.503 2.503 0 0 1 4 18.5v-13A2.503 2.503 0 0 1 6.5 3Zm11.707 16.207a1 1 0 0 0 .293-.707v-13a1 1 0 0 0-1-1h-11a1 1 0 0 0-1 1v13a1 1 0 0 0 1 1h11a1 1 0 0 0 .707-.293ZM7.5 7h9v1.5h-9V7Zm9 3h-9v1.5h9V10Zm-9 3h5v1.5h-5V13Z"}})])
          )
        }
      }
    